import * as amplitude from '@amplitude/analytics-browser';
import { useMsal } from '@azure/msal-react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/reducers';

export const useAmplitudeEvents = () => {
  const {
    accounts,
    // instance,
  } = useMsal();
  const { countryCode, modules } = useSelector(
    (state: RootState) => {
      return {
        countryCode: state.auth.countryCode,
        modules: state.generic.ListOfModules
      };
    }
  );

  const getAmplitudeApiKey: any = () => {
    console.log('Country Code:', countryCode);
    switch (countryCode) {
      case 'PK':
        return process.env.REACT_APP_PK_AMPLITUDE_KEY;
      case 'ID':
        return process.env.REACT_APP_ID_AMPLITUDE_KEY;
      case 'BD':
        return process.env.REACT_APP_BD_AMPLITUDE_KEY;
      case 'TH':
        return process.env.REACT_APP_TH_AMPLITUDE_KEY;
      case 'MY':
        return process.env.REACT_APP_MY_AMPLITUDE_KEY;
      case 'VN':
        return process.env.REACT_APP_VN_AMPLITUDE_KEY;
      case 'PH':
        return process.env.REACT_APP_PH_AMPLITUDE_KEY;
      case 'ZM':
        return process.env.REACT_APP_ZM_AMPLITUDE_KEY;
      case 'KR':
        return process.env.REACT_APP_KR_AMPLITUDE_KEY;
      default:
        return '';
    }
  }

  const initAmplitude = () => {
    const amplitudeApiKey = getAmplitudeApiKey();
    const enableAmplitude = modules.filter(module => module.serviceName === 'Community/Social plus')?.length > 0;
    if (amplitudeApiKey && enableAmplitude) {
      amplitude.init(getAmplitudeApiKey(), {
        autocapture: false
      });
      setTimeout(() => {
        amplitude.setUserId('');
        trackUserProperties();
      }, 1500);
    }
  };

  const logEvent = (eventName: string, eventProperties?: any) => {
    const enableAmplitude = modules.filter(module => module.serviceName === 'Community/Social plus')?.length > 0;
    if (enableAmplitude) {
      amplitude.logEvent(eventName, eventProperties);
    }
  };

  const trackUserProperties = (
  ) => {

    const identify = new amplitude.Identify();
    identify.set('username', accounts[0]?.name ?? '');
    identify.set('email', accounts[0]?.username ?? '');
    amplitude.identify(identify);
  };

  return { initAmplitude, logEvent };
}

export const EventConstants = {
  Comm_Admin_Portal_Social_Plus_Clicked: "Comm_Admin_Portal_Social_Plus_Clicked",
}